import type { components, paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const RELOCATION_ORDER_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_BCA_INIT_API_PATH = "/v1/relocation-order/flow/bca/init" as const;

export type RelocationOrderBcaInitBody =
  paths[typeof RELOCATION_ORDER_BCA_INIT_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type RelocationOrderBcaInitResponse = components["schemas"]["RelocationOrderResponseDto"];
export type RelocationOrderAlreadyOpenErrorResponse =
  components["schemas"]["RelocationOrderAlreadyOpenErrorResponseDto"];

export const useRelocationOrderBcaInitMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RelocationOrderBcaInitResponse, Error, RelocationOrderBcaInitBody>({
    mutationFn: async (body: RelocationOrderBcaInitBody) => {
      const response = await alphartisApiAxios.post<RelocationOrderBcaInitResponse>(
        RELOCATION_ORDER_BCA_INIT_API_PATH,
        body,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [RELOCATION_ORDER_RESOURCE],
      });
    },
  });
};
